<div class="receipt-send-box" [ngClass]="getDynamicClass()">
  <h3 class="w-100 text-center mb-2 total-text">{{ "Total" | translate | async }}</h3>
  <h1 class="w-100 text-center receipt-amount">
    {{ globalAmount | currency : currency : "symbol" : "1.2-2" }}
  </h1>
  <div class="send-inputs">
    <span
      class="d-inline-block w-100 text-center text-bold mb-3 receipt-info-text"
      >{{ "How do you want to receive your receipts?" | translate | async }}</span
    >
    <hr style="margin-top: 0px" />
    <div class="form-group mb-2">
      <label style="font-size: 14px">{{ "Email" | translate | async }}</label>
      <div class="input-group">
        <span class="input-group-text bg-transparent border-end-0"
          ><i class="fas fa-envelope"></i
        ></span>
        <input
          type="text"
          class="form-control border-end-0 border-start-0"
          [placeholder]="'Email' | translate | async"
          aria-label="Email"
          aria-describedby="basic-addon2"
          id="email"
          name="email"
          [(ngModel)]="email"
          (ngModelChange)="validateEmail()"
          autocomplete="autocomplete_off_randString"
        />
        <button
          style="background-color: #000; color: #fff"
          class="input-group-text btn-dark eatos-submit-btn f-14"
          id="basic-addon2"
          [disabled]="emailMsg != '' || email == '' || !disableSendbtn"
          (click)="sendReceiptToEmail()"
        >
          {{ "Send" | translate | async }}
        </button>
      </div>
      <span class="mt-1 input-invalid-error">{{ emailMsg }}</span>
    </div>
    <div class="form-group">
      <label style="font-size: 14px">{{ "Phone Number" | translate | async }}</label>
      <div class="custom-intl-input-group">
        <ngx-intl-tel-input
          [cssClass]="'trm-intel-input form-control input-group-intl'"
          [preferredCountries]="preferredCountries"
          [enableAutoCountrySelect]="true"
          [enablePlaceholder]="true"
          [searchCountryFlag]="true"
          [searchCountryField]="[
            SearchCountryField?.Iso2,
            SearchCountryField.Name
          ]"
          [phoneValidation]="true"
          name="phone"
          [(ngModel)]="phone"
          (ngModelChange)="validatePhone()"
          autocomplete="autocomplete_off_randString"
        >
        </ngx-intl-tel-input>
        <!-- [disabled]="errormsg || phone == null || !disableSendbtn" -->
        <button
          style="height: 38px"
          class="input-group-text btn-pink eatos-submit-btn f-14"
          [disabled]="phoneMsg || phone == null"
          id="basic-addon2"
          (click)="sendReceiptMobile()"
        >
          {{ "Send" | translate | async }}
        </button>
      </div>
      <!-- <span *ngIf="errormsg" class="mt-1 input-invalid-error">Mobile number is not of selected country</span> -->
      <span *ngIf="phoneMsg" class="mt-1 input-invalid-error f-14"
        >{{ "Mobile number is not of selected country" | translate | async }}</span
      >
    </div>
    <p class="text-center mt-2 receipt-disclaimer f-14">
      {{ "Digital receipts delivered by eatOS. See your digital receipt for privacy policy and preferences." | translate | async }}
    </p>
  </div>
</div>
